jQuery.noConflict();
(function ($) {
    $(function () {
    $(document).ready(function() {
        $("#pill-toggle-checkbox").on("click", (evt) => {
             that=this;
            if($(that).checked) {
                $("#pill-toggle-checkbox-description")[0].innerText="On"
                $('#pill-toggle-checkbox-label').attr('aria-pressed', true);
            }
            else{
                $("#pill-toggle-checkbox-description")[0].innerText="Off"
                $('#pill-toggle-checkbox-label').attr('aria-pressed', false);
            }
            $('#same-day-service-selected').val($("#pill-toggle-checkbox")[0].checked);

            if ($('#pill-toggle-checkbox').parents('.same-day-service-selection-join').length>0)
            {
                var dataPrefix = 'sds';
                var sameDayServiceFrmEle = $('#pill-toggle-checkbox').parents('.same-day-service-selection-join');
                var sameDayServiceFrm = $('#pill-toggle-checkbox').parents('.same-day-service-selection-join').sitecoreAjaxForm({
                    errorOptions: {
                        containerWrapper: '.form__error.form__error-summary'
                    },
                    onSuccess: function (data, preventDefault) {
                        var refreshTotalTarget =  $(sameDayServiceFrmEle).data(dataPrefix + 'RefreshTotalTarget');
                        $(refreshTotalTarget).text(data.NewOrderTotal.toFixed(2));
                    }
                });
                sameDayServiceFrm.submit(); 
            }
        });

        $(".upgrade-membership__container").on("click",".pill-toggle-checkbox", (evt) => {
            
            var itemCount=$("#"+this.activeElement.id).data("item-count");
                var checkboxid="#pill-toggle-checkbox-"+itemCount;
                if($(checkboxid)[0].checked) {
                    $("#pill-toggle-checkbox-description-"+itemCount)[0].innerText="On"
                    $("#pill-toggle-checkbox-label-"+itemCount).attr('aria-pressed', true);
                }
                else{
                    $("#pill-toggle-checkbox-description-"+itemCount)[0].innerText="Off"
                    $("#pill-toggle-checkbox-label-"+itemCount).attr('aria-pressed', false);
                }
                $('#same-day-service-selected').val($(checkboxid)[0].checked);
    

             if ($(".same-day-service-selection-upgrade").length > 0)
                {
                    if ($("#upgrade_package_"+itemCount)[0].checked){
                         var upgradeAmount=parseFloat($("#progress-bar-total").html());
                        var sameDayServiceAmountWithTax= parseFloat($("#same-day-service-upgrade-amount").val());
                        var newAmount=0.0;
                        if ($("#pill-toggle-checkbox-"+itemCount)[0].checked)
                        {
                            newAmount=upgradeAmount+sameDayServiceAmountWithTax;
                        }
                        else
                        {
                            newAmount=upgradeAmount-sameDayServiceAmountWithTax;
                        }
                        $("#progress-bar-total").html(newAmount.toFixed(2)); 
                    }
                }
     
            }); 
        })

    })
})(jQuery);


/* jQuery.noConflict();
(function ($) {
$(function () {
    const pillToggleContainer =  document.getElementById('pill-toggle-checkbox');
    const pillToggleLabelContainer = document.getElementById('pill-toggle-checkbox-label');
    const pillToggleDescription = document.getElementById('pill-toggle-checkbox-description');
    const sameDayServiceSelected = document.getElementById('same-day-service-selected');

    if (pillToggleContainer != null)
    {
        pillToggleContainer.addEventListener('click', (evt) => {
        // evt.preventDefault();
        that=this;
            if(pillToggleContainer.checked) {
                //pillToggleDescription.innerText = "On" ;
                $("#pill-toggle-checkbox-description")[0].innerText="On"
                pillToggleLabelContainer.setAttribute('aria-pressed', true);
            }
            else{
            // pillToggleDescription.innerText = "Off" ;
                $("#pill-toggle-checkbox-description")[0].innerText="Off"
                pillToggleLabelContainer.setAttribute('aria-pressed', false);
            }
            sameDayServiceSelected.value=pillToggleContainer.checked

            if ($('#pill-toggle-checkbox').parents('.same-day-service-selection-join').length>0)
            {
                var dataPrefix = 'sds';
                var sameDayServiceFrmEle = $('#pill-toggle-checkbox').parents('.same-day-service-selection-join');
                var sameDayServiceFrm = $('#pill-toggle-checkbox').parents('.same-day-service-selection').sitecoreAjaxForm({
                    errorOptions: {
                        containerWrapper: '.form__error.form__error-summary'
                    },
                    onSuccess: function (data, preventDefault) {
                        var refreshTotalTarget =  $(sameDayServiceFrmEle).data(dataPrefix + 'RefreshTotalTarget');
                        $(refreshTotalTarget).text(data.NewOrderTotal.toFixed(2));
                    }
                });
                sameDayServiceFrm.submit(); 
            }
            if ($('#pill-toggle-checkbox').parents('.same-day-service-selection-upgrade').length>0)
            {
                
                var upgradeAmount=parseFloat($("#progress-bar-total").html());
                var sameDayServiceAmountWithTax=parseFloat($("#same-day-service-amount").data("same-day-service-amount-with-tax"));
                var newAmount=0.0;
                if (pillToggleContainer.checked)
                {
                    newAmount=upgradeAmount+sameDayServiceAmountWithTax;
                }
                else
                {
                    newAmount=upgradeAmount-sameDayServiceAmountWithTax;
                }
                $("#progress-bar-total").html(newAmount);
            }


        });
    }
})
})(jQuery); */

 /* 
jQuery.noConflict();
(function ($) {
    $(function () {
    const pillToggleContainer =  document.getElementById('pill-toggle-checkbox');
    const pillToggleLabelContainer = document.getElementById('pill-toggle-checkbox-label');
    const pillToggleDescription = document.getElementById('pill-toggle-checkbox-description');
    const sameDayServiceSelected = document.getElementById('same-day-service-selected');
    
    if (pillToggleContainer != null)
    {
    pillToggleContainer.addEventListener('click', function (evt) {
        evt.preventDefault();
        that = this;
        var isChecked =pillToggleContainer.checked;
        if(isChecked) {
            pillToggleLabelContainer.setAttribute('aria-pressed', true);
            pillToggleDescription.textContent = "On";
        }
        else{
            pillToggleLabelContainer.setAttribute('aria-pressed', false);
            pillToggleDescription.textContent = "Off";
        }
        sameDayServiceSelected.value=isChecked

        var event = jQuery.Event("SameDayServiceSelectionEvent");
        $( "body" ).trigger( event );

      
        var dataPrefix = 'sds';
        var sameDayServiceFrmEle = $(that).parents('.same-day-service-selection');
        var sameDayServiceFrm = $(sameDayServiceFrmEle).sitecoreAjaxForm({
            errorOptions: {
                containerWrapper: '.form__error.form__error-summary'
            },
            onSuccess: function (data, preventDefault) {
                var refreshTotalTarget = sameDayServiceFrmEle.data(dataPrefix + 'RefreshTotalTarget');
                $(refreshTotalTarget).text(data.NewOrderTotal.toFixed(2));
            }
        });
        sameDayServiceFrm.submit(); 

        });
}
})
})(jQuery);*/